import type { Resource } from '../../';
export const search_box_placeholder: Resource = {"default":"Search..."};
